import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Reviews from './pages/Reviews';
import Comparisons from './pages/Comparisons';
import Bonuses from './pages/Bonuses';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import TermsOfService from './pages/TermsOfService';
import ScrollToTop from './components/ScrollToTop';
import AgeVerification from './components/AgeVerification';
import CookieConsent from './components/CookieConsent';
import './App.css';

function App() {
  return (
    <Router>
      <AgeVerification />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/comparisons" element={<Comparisons />} />
        <Route path="/bonuses" element={<Bonuses />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
      </Routes>
      <CookieConsent />
    </Router>
  );
}

export default App;
